// "Gallery · Field" wordmark — Schibsted Grotesk 800 with the "Link"
// syllable in the pine accent. Replaces the legacy per-section recoloured
// SVG logo; the brand now uses a single constant colour.
export default function Logo({ className = '' }) {
    return (
        <span className={`gf-wm ${className}`} aria-label="TripLinkHub">
            Trip<span>Link</span>Hub
        </span>
    );
}
